import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IUsageType } from '@api/types'
import { UsageTypeFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  viewer: {
    company: {
      types: { usageType: IUsageType[] }
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, IUsageType[]>({
  handler: (data) => data.viewer.company.types.usageType,
  name: 'UsageType',
})

export default function usageTypes(): Promise<IUsageType[]> {
  return client.gql.query({ query: usageTypeQuery }).then(mutateHandler)
}

export const usageTypeQuery = gql`
  query usageTypes {
    viewer {
      company {
        types {
          usageType {
            ...UsageTypeFragment
          }
        }
      }
    }
  }
  ${UsageTypeFragment}
`
